<template>
  <div class="contenido-colores">
    <div class="block-title"><h2>Selecciona tu color</h2></div>
    <div class="contenido-colores_cont">
      <div class="banner-imagen-colores" v-if="company">
        <img v-if="categorySlug === 'color-gel'" :src="getImage(`base_${company.portal_id}`)" class="fluid"/>
        <img v-else-if="categorySlug === 'glitter'" :src="getImage(`base_glitter_${company.portal_id}`)" class="fluid"/>
      </div>
      <div class="colores">
        <div v-for="color of colors" class="item" style="margin: 1px">
            <router-link :to="{ path: '/products/' + encodeURIComponent(color.online_store_slug)}">
              <img :src="getMediaPath(color.online_store_thumbnail)" class="img-block"/>
              <h3>{{ color.color }}</h3>
            </router-link>
            <div class="cont-block"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { colors } from '@/data/colors'; // check later
import LoadingMixin from '@/plugins/Common/LoadingMixin.js'
import { mapGetters } from 'vuex';
export default {
  name: "ColorSelector",
  props: ['categorySlug'],
  data() {
    return {
        colors: [],
        images: {
          base_acry_love_sas: require('@/assets/img/common/frasco-acry-love.png'),
          base_glitter_acry_love_sas: require('@/assets/img/common/glitter-acry-love.png'),

          base_mcnails_colombia_sas: require('@/assets/img/common/frasco-mc-nails.png'),
          base_glitter_mcnails_colombia_sas: require('@/assets/img/common/glitter-mc-nails.png')
        }
    };
  },
  components: {},
  computed: {
      ...mapGetters({
          company: "general/allInfo",
      }),
  },
  methods: {
    getImage (key) {
      if (key in this.images) {
        return this.images[key]
      }
      return null
    },
    load () {
      if (this.statusIsLoading()) return

      const query = this.$Models.Product.query()

      query.where('category_online_store_slug', this.categorySlug)

      query.where('online_store_thumbnail', '!=', 'null')

      query.orderBy('sku_int ASC')

      query.forPage(1)

      this.colors = []

      this.statusLoading()
      query.get()
        .then(res => {
          return res
        })
        .then(res => {
          this.colors = res.items
          this.statusLoadingComplete()
        })
        .catch((err) => {
          this.statusLoadingFail()
          this.showError(err)
        })
    },
  },
  mixins: [LoadingMixin],
  watch: {
    categorySlug (nVal, oVal) {
      if (nVal !== oVal) {
        this.load()
      }
    }
  },
  mounted () {
    this.load()
  }
};
</script>
